var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import React from "react";
import StatusInfoPopUp from "../StatusInfoPopUp/StatusInfoPopUp";
var StatusInfo = function (props) {
    var StyledWrapper = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    };
    var StyledMainContainer = {
        display: "flex",
        alignItems: "center",
    };
    var StyledStatusText = {
        color: "var(--grey-color-70)",
        fontFamily: "var(--font-stack-full-heavy)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 800,
        lineHeight: "24px",
        textTransform: "capitalize",
    };
    var StyledCircle = {
        width: "14px",
        height: "14px",
        gap: "10px",
        border: "1px solid",
        borderRadius: "34px",
        padding: "9px",
    };
    var StyledLeftPanel = {
        display: "flex",
        flexDirection: "row",
        gap: "12px",
        alignItems: "center",
    };
    return (_jsxs(Box, __assign({ sx: StyledWrapper }, { children: [_jsxs(Box, __assign({ sx: StyledMainContainer }, { children: [_jsx(Box, __assign({ sx: __assign(__assign({}, StyledStatusText), { fontSize: "18px" }) }, { children: props === null || props === void 0 ? void 0 : props.heading })), _jsx(Box, __assign({ sx: { paddingLeft: "8px" } }, { children: _jsx(Box, __assign({ sx: {
                                display: "flex",
                                width: "36px",
                                height: "36px",
                                padding: "8px",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "40px",
                                background: "var(--Grey-100, var(--grey-color-10))",
                            } }, { children: _jsx(StatusInfoPopUp, { description: "Scores range from 1% to 100% based on type of metric selected.", popupText: {
                                    act: "Overall, leaders have significant gaps against multiple role requirements" +
                                        ". Recommend immediate action to address greatest gaps and risk areas.",
                                    watch: "Leaders generally have small to moderate gaps against some role requirements" +
                                        ". Recommend closely monitoring and/or proactively managing areas of highest risk.",
                                    maintain: "Leaders are generally meeting or exceeding most role requirements. " +
                                        "Recommend leveraging key strengths while noting any potential areas of opportunity.",
                                }, colors: [
                                    {
                                        backgroundColor: "var(--bad-1)",
                                        borderColor: "var(--bad-2)",
                                    },
                                    {
                                        backgroundColor: "var(--neutral-1)",
                                        borderColor: "var(--neutral-2)",
                                    },
                                    {
                                        backgroundColor: "var(--good-1)",
                                        borderColor: "var(--good-2)",
                                    },
                                    {
                                        backgroundColor: "var(--grey-color-400)",
                                        borderColor: "var(--primary-text)",
                                    },
                                ] }) })) }))] })), _jsx(Box, __assign({ sx: StyledLeftPanel }, { children: props.data.map(function (item, index) { return (_jsxs(React.Fragment, { children: [_jsx(Box, { sx: __assign(__assign({}, StyledCircle), { backgroundColor: item.bgColor, borderColor: item.brColor }) }), _jsx(Box, __assign({ sx: StyledStatusText }, { children: item.text })), index < props.data.length - 1 && (_jsx(Box, { sx: {
                                width: "1px",
                                height: "18px",
                                backgroundColor: "var(--grey-gradient-end-color-10)",
                            } }))] }, index)); }) }))] })));
};
export default StatusInfo;
